module.exports = __webpack_public_path__ + "img/logo.0c59ee07.png";